/**
 * Escolha da fonte de dados.
 *
 * `VITE_DEMO=1` força o modo demo; sem as chaves do Firebase, ele é o único caminho possível.
 * A instância é preguiçosa porque `createFirestoreSource` toca no Firebase, e isso só pode
 * acontecer depois de haver configuração válida.
 */

import { hasFirebaseConfig } from '../lib/firebase.js';
import { createDemoSource } from './demoSource.js';
import { createFirestoreSource } from './firestoreSource.js';
import type { DataSource } from './types.js';

const forceDemo = import.meta.env.VITE_DEMO === '1';

export const isDemoMode = forceDemo || !hasFirebaseConfig;

let cached: DataSource | null = null;

export function getDataSource(): DataSource {
  if (!cached) cached = isDemoMode ? createDemoSource() : createFirestoreSource();
  return cached;
}

export * from './types.js';
